export default "__VITE_ASSET__SGj9mgOw__"